import * as yup from "yup";

export const formSchema = yup.object().shape({
  name: yup.mixed().nullable().required("Nama tag grup diperlukan"),
  description: yup.mixed().nullable().required("Deskripsi diperlukan"),
  itemPrefix: yup.mixed().nullable().required("Tag prefix diperlukan"),
  newTags: yup.mixed().nullable().required("Tag diperlukan"),
});
